module.exports = __webpack_public_path__ + "static/media/5.4ee7e491.jpg";